import { apiFetch } from './apiFetch'

/**
 * A member of the department's staff. Not a complainant -- children who file
 * complaints have no account and never will, which is the point of Form DC-1.
 */
export interface Staff {
  id: number
  emailAddress: string
  firstName: string | null
  lastName: string | null
  createdAt: number
  updatedAt: number
}

export const PASSWORD_MINIMUM = 8

export function signIn(emailAddress: string, password: string): Promise<Staff> {
  return apiFetch<Staff>('/app/login', {
    method: 'POST',
    body: JSON.stringify({ emailAddress, password }),
  })
}

/** Who is signed in. Throws a 401 when nobody is, which is a normal answer. */
export function currentStaff(): Promise<Staff> {
  return apiFetch<Staff>('/app/session')
}

export function signOut(): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/app/session', { method: 'DELETE' })
}

export function changePassword(currentPassword: string, newPassword: string): Promise<{ ok: boolean }> {
  return apiFetch<{ ok: boolean }>('/app/password', {
    method: 'POST',
    body: JSON.stringify({ currentPassword, newPassword }),
  })
}
